import TradingCalendar from "../TradingCalendar";
import { useDashboardData } from "./DashboardDataContext";

export default function CalendarWidget() {
  const {
    trades,
    routines,
    goals,
    accounts,
    groups,
    sessions,
    accountEvents,
    fundedEvents,
    payoutEvents,
    violationsByDate,
    setSelectedMonth,
    setSelectedDay,
  } = useDashboardData();

  return (
    <div className="h-full overflow-hidden">
    <TradingCalendar
      trades={trades}
      routines={routines || []}
      goals={goals || []}
      accounts={(accounts || []) as any[]}
      groups={(groups || []) as any[]}
      accountEvents={accountEvents}
      fundedEvents={fundedEvents}
      payoutEvents={payoutEvents}
      sessions={(sessions || []) as any[]}
      violationsByDate={violationsByDate}
      onMonthChange={setSelectedMonth}
      onDayClick={setSelectedDay}
    />
    </div>
  );
}
